let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("kNFvF"), load("2ttoy")]).then(() => parcelRequire('1Ve5d'));